import { useQuery } from 'react-query';

import { MatterDocFilterOptions } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterDocFilterValues = (matterId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<MatterDocFilterOptions>(
    [QueryEntity.MatterDocFilterValues, matterId],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/matters/${matterId}/docs/filter-values`, fetchConfigGET);

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      return res.json();
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!matterId,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    },
  );
};
